import { Component, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AvailableUpdateDetail } from 'src/app/data-models/system-update/available-update-detail.model';
import { UpdateActionResult } from 'src/app/enums/update-action-result.enum';
import { UpdateInstallSeverity } from 'src/app/enums/update-install-severity.enum';
import { CommonService } from 'src/app/services/common/common.service';
import { LanguageService } from 'src/app/services/language/language.service';
import { ModalUpdateChangeLogComponent } from '../../modal/modal-update-change-log.component/modal-update-change-log.component';

@Component({
	selector: 'vtr-ui-list-checkbox',
	templateUrl: './ui-list-checkbox.component.html',
	styleUrls: ['./ui-list-checkbox.component.scss'],
})
export class UiListCheckboxComponent implements OnDestroy {
	@Input() items: Array<AvailableUpdateDetail>;
	@Input() isInstallationSuccess = false;
	@Input() isInstallationCompleted = false;
	@Input() isUpdateDownloading = false;
	@Output() readMore = new EventEmitter<any>();
	@Output() ignoreUpdate = new EventEmitter<any>();
	@Output() checkChange = new EventEmitter<{ name: string; checked: boolean }>();

	public manufacturer: string;
	public version: string;
	public installedVersion: string;
	public installedVersionStatus = 0;
	public downloadSize: string;
	public diskSpaceNeeded: string;
	public readMeUrl = '';
	public packageRebootType: string;
	public isReadMeAvailable = false;
	public isIgnored = false;
	public severity = UpdateInstallSeverity.Optional;
	public UpdateInstallSeverity = UpdateInstallSeverity;
	public packageName: string;
	public packageID: string;

	public notInstalledText = 'systemUpdates.notInstalled';
	public notAvailableText = 'systemUpdates.notAvailable';
	private currentToolTip;
	private currentQuestionMarkID;
	translate1Subscription: Subscription;
	translate2Subscription: Subscription;
	public UpdateActionResult = UpdateActionResult;

	constructor(
		private commonService: CommonService,
		private modalService: NgbModal,
		private translate: TranslateService
	) {
		this.translateString();
	}

	onCheckChange($event: boolean, item: AvailableUpdateDetail) {
		this.checkChange.emit({
			name: item.packageName,
			checked: $event,
		});
	}

	initSystemUpdateToolTip(update: AvailableUpdateDetail) {
		this.packageID = update.packageID;
		this.isIgnored = update.isIgnored;
		this.severity = update.packageSeverity;
		this.packageName = update.packageName;
		this.isReadMeAvailable = false;
		this.manufacturer = update.packageVendor;
		this.version = update.packageVersion;
		this.downloadSize = this.commonService.formatBytes(parseInt(update.packageSize, 10));
		this.diskSpaceNeeded = this.commonService.formatBytes(
			parseInt(update.diskSpaceRequired, 10)
		);
		this.readMeUrl = update.readmeUrl;
		this.packageRebootType = update.packageRebootType;
		if (this.readMeUrl && this.readMeUrl.length > 0 && this.readMeUrl.startsWith('http', 0)) {
			this.isReadMeAvailable = true;
		}
		this.installedVersion = update.currentInstalledVersion;

		if (
			update.currentInstalledVersion === null ||
			update.currentInstalledVersion === undefined
		) {
			this.installedVersionStatus = 1; // notInstalledText;
		} else if (
			update.currentInstalledVersion.trim() === '' ||
			update.currentInstalledVersion.trim().length === 0
		) {
			this.installedVersionStatus = 1; // notInstalledText;
		} else if (update.currentInstalledVersion === '0') {
			this.installedVersionStatus = 2; // notAvailableText;
		} else {
			this.installedVersionStatus = 0;
		}
	}

	onTooltipClick(update: AvailableUpdateDetail) {
		this.currentQuestionMarkID = document.activeElement.id;
		this.initSystemUpdateToolTip(update);
	}

	@HostListener('window:keyup', ['$event'])
	onKeyUp(event: KeyboardEvent) {
		if ((event.shiftKey && event.key === 'Tab') || event.key === 'Tab') {
			const activeId = document.activeElement.id || '';
			this.CloseToolTip(activeId);
		}
	}

	CloseToolTip(activeId) {
		if (
			activeId &&
			activeId.indexOf('su-package-readme-') < 0 &&
			activeId.indexOf('su-ignore-update-') < 0 &&
			activeId.indexOf('su-unignore-update-') < 0 &&
			activeId.indexOf('su-attend-update-') < 0 &&
			this.currentToolTip &&
			this.currentToolTip.isOpen()
		) {
			this.currentToolTip.close();
		}
	}

	public onReadMoreClick($event) {
		this.readMore.emit($event);
		// const readMeUrl = 'https://download.lenovo.com/consumer/desktop/lnvusbss.txt';
		const updateModalMetrics = {
			pageName: 'Page.Device.SystemUpdate',
			pageContext: 'Read More',
			closeButton: 'ReadMoreCloseButton',
		};
		const modalRef = this.modalService.open(ModalUpdateChangeLogComponent, {
			backdrop: true,
			size: 'lg',
			windowClass: 'update-read-more-modal-size',
			centered: true,
		});
		modalRef.componentInstance.url = this.readMeUrl;
		modalRef.componentInstance.updateModalMetrics = updateModalMetrics;
		this.focusOnElement(this.currentQuestionMarkID);
	}

	public onIgnoreUpdateClick(
		packageName: string,
		isIgnored: boolean,
		packageSeverity: UpdateInstallSeverity
	) {
		this.ignoreUpdate.emit({ packageName, isIgnored, packageSeverity });
	}

	private translateString() {
		this.translate1Subscription = this.translate
			.stream(this.notAvailableText)
			.subscribe((res) => {
				this.notAvailableText = res;
			});
		this.translate2Subscription = this.translate
			.stream(this.notInstalledText)
			.subscribe((res) => {
				this.notInstalledText = res;
			});
	}

	private focusOnElement(element) {
		if (element && document.getElementById(element)) {
			document.getElementById(element).focus();
		}
	}

	public getFormatedDownloadSize(size) {
		return this.commonService.formatBytes(parseInt(size, 10));
	}

	ngOnDestroy() {
		if (this.translate1Subscription) {
			this.translate1Subscription.unsubscribe();
		}
		if (this.translate2Subscription) {
			this.translate2Subscription.unsubscribe();
		}
	}
}
